import _ from "lodash";

export const buildTwoTapPopupStylesheet = (builder, device, cta, variant) => {
    let options = { ...variant.options };

    let prehookPosition;

    if (
      builder !== true &&
      (!options["prehook-position"] || options["prehook-position"] == "right")
    ) {
      prehookPosition = "right: 20px !important;";
    }

    if (builder !== true && options["prehook-position"] == "left") {
      prehookPosition = "left: 20px !important;";
    }

    if (builder !== true && options["prehook-position"] == "center") {
      prehookPosition = `
        right: 50% !important;
        left: 50% !important;
        transform: translate(-50%, 0%) !important;
        animation: initial !important;
        transition: initial !important;
`;
    }

    if (builder == true) {
      if (options["prehook-position"] == "left") {
        prehookPosition =
          "display: block !important; margin-left: 0 !important; margin-right: auto !important;";
      } else if (options["prehook-position"] == "center") {
        prehookPosition =
          "display: block !important; margin-left: auto !important; margin-right: auto !important;";
      } else {
        prehookPosition =
          "display: block !important; margin-left: auto !important; margin-right: 0 !important;";
      }
    }

    let prehookPopupPosition = "";
    if (options["prehook-position"] == "left") {
      prehookPopupPosition =
        builder == true
          ? "margin-left: 0 !important; margin-right: auto !important;"
          : "left: 30px !important; right: auto !important;";
    } else if (options["prehook-position"] == "center") {
      prehookPopupPosition =
        builder == true
          ? "margin-left: auto !important; margin-right: auto !important;"
          : `
        left: 50% !important;
        right: auto !important;
        transform: translateX(-50%) !important;
        animation: initial !important;
        transition: initial !important;
`;
    } else if (options["prehook-position"] == "right" && builder == true) {
      prehookPopupPosition =
        "margin-left: auto !important; margin-right: 0 !important;";
    }

    let borderRadius = "0px";
    if (options["prehook-button-radius"] == "cf-not-rounded") {
      borderRadius = "0px";
    }
    if (options["prehook-button-radius"] == "cf-slightly-rounded") {
      borderRadius = "4px";
    }
    if (options["prehook-button-radius"] == "cf-fully-rounded") {
      borderRadius = "100px";
    }
    if (options["prehook-button-radius"] == "custom") {
      borderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          borderRadius += `${
            _.isNil(options["prehook-button-radius-" + side]) == false
              ? options["prehook-button-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    // prettier-ignore
    let desktopStyles = 
`.cf-two-tap[data-cta-id="${cta.id}"] {
  cursor: pointer;
  background: ${options['prehook-button-color'] ? options['prehook-button-color'] : '#007aec'} !important;
  min-height: 40px;
  position: ${builder == true ? 'relative' : 'fixed'};
  display: ${builder == true ? 'inline-block' : 'none'};
  width: fit-content;
  min-width: 100px;
  bottom: ${builder == true ? 'initial' : '20px'};
  z-index: 100002;
  overflow: hidden;
  user-select: none;
  border: initial !important;
  border-style: ${options["prehook-button-border-style"] ? options["prehook-button-border-style"] : 'none'} !important;
  border-width: ${_.isNil(options["prehook-button-border-width"]) == false ? options["prehook-button-border-width"] : 2}px !important;
  border-left-width: ${_.isNil(options["prehook-button-border-width-left"]) == false ? options["prehook-button-border-width-left"] : _.isNil(options["prehook-button-border-width"]) == false ? options["prehook-button-border-width"] : 2}px !important;
  border-right-width: ${_.isNil(options["prehook-button-border-width-right"]) == false ? options["prehook-button-border-width-right"] : _.isNil(options["prehook-button-border-width"]) == false ? options["prehook-button-border-width"] : 2}px !important;
  border-top-width: ${_.isNil(options["prehook-button-border-width-top"]) == false ? options["prehook-button-border-width-top"] : _.isNil(options["prehook-button-border-width"]) == false ? options["prehook-button-border-width"] : 2}px !important;
  border-bottom-width: ${_.isNil(options["prehook-button-border-width-bottom"]) == false ? options["prehook-button-border-width-bottom"] : _.isNil(options["prehook-button-border-width"]) == false ? options["prehook-button-border-width"] : 2}px !important;
  border-color: ${options["prehook-button-border-color"] ? options["prehook-button-border-color"] : '#000'} !important;
  ${borderRadius ? 'border-radius: ' + borderRadius + ' !important;' : ''}
  ${prehookPosition}
}

.cf-two-tap[data-cta-id="${cta.id}"] .cf-two-tap-close {
  position: absolute;
  display: flex;
  width: 21px;
  height: 36px;
  align-items: center;
  justify-content: center;
  right: 5px;
  font-family: Verdana, Arial, sans-serif;
  font-size: 19px;
  text-align: left;
  color: ${options["prehook-button-font-color"] ? options["prehook-button-font-color"] : '#fff'} !important;
  z-index: 100003;
  padding-top: 4px;
}

.cf-two-tap[data-cta-id="${cta.id}"] .cf-two-tap-close svg {
  width: 21px;
}

.cf-two-tap[data-cta-id="${cta.id}"] .cf-two-tap-message {
  margin-right: 20px;
  padding: 0px 15px;
}

.cf-two-tap[data-cta-id="${cta.id}"] .cf-two-tap-message p {
  all: initial !important;
  cursor: pointer !important;
  text-align: center !important;
  font-family: Helvetica, Arial, sans-serif !important;
  margin: 0 !important;
  line-height: 40px !important;
  color: ${options['prehook-text-color'] ? options['prehook-text-color'] : '#fff'} !important;
  width: 100% !important;
  display: inline-block !important;
  user-select: none !important;
  font-size: ${options["prehook-button-size"] ? options["prehook-button-size"] : '16'}px !important;
  font-family: ${options["prehook-button-font"] ? options["prehook-button-font"] + ', ' : ''}Helvetica, Arial, sans-serif !important;
  font-weight: ${options['prehook-button-font-weight'] ? options['prehook-button-font-weight'] : '700'} !important;
  color: ${options["prehook-button-font-color"] ? options["prehook-button-font-color"] : '#fff'} !important;
  white-space: nowrap !important;
}

.cf-prehook-popup[data-cta-id="${cta.id}"] {
  ${prehookPopupPosition}
}
`;

    if (builder == true && variant.options["trigger_type"] == "prehook") {
      desktopStyles += `
    .cta${cta.id}.cf-prehook-popup {
      position: relative !important;
      bottom: initial !important;
      right: initial !important;
    }

    .cta${cta.id}.cf-prehook-popup .prehook-message p {
      margin: 0 !important; 
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important; 
      font-size: 16px !important; 
      color: #6f818e; 
      line-height: 1.4 !important; 
      padding: 0px; 
      -webkit-font-smoothing: subpixel-antialiased; 
      -moz-osx-font-smoothing: initial; 
      font-smoothing: subpixel-antialiased;
    }
`;
    }

    let buttonFontSizeMobile;
    if (options["prehook-button-size-mobile"]) {
      buttonFontSizeMobile = options["prehook-button-size-mobile"];
    }

    // prettier-ignore
    const mobileStyles = 
`/* mobile styles */

.cf-two-tap[data-cta-id="${cta.id}"] .cf-two-tap-message p {
  ${buttonFontSizeMobile ? `font-size: ${buttonFontSizeMobile}px !important;` : ''}
}

`;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
